<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div v-if="tab == 'summary' && selectedSummaryType == 'customer'">
            <div class="row">
                <div class="col-sm-12 col-md-6 mb-2">
                    <date-range-picker class="w-100"
                        :minDate="minDate"
                        ref="picker"
                        v-model="dateBalance"
                        :opens="'right'"
                        :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                        :autoApply="true"
                        :showDropdowns="true" 
                        :always-show-calendars="true"
                        :single-date-picker="true"
                        :ranges="false"
                        @showCustomRange="showCustomRangeCalendars=true"
                        @update="filterByEndDate">
                    </date-range-picker>
                </div>
                <div class="col-sm-12 col-md-6 mb-2">
                    <div class="dataTables_filter mb-2">
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchCredit" @keypress.enter="filterSearch">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearch">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="dataTables_filter mb-2">
                <label class="d-flex mb-0">
                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchCredit" @keypress.enter="filterSearch">
                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearch">
                        <i class="fas fa-search"></i>
                    </button>
                </label>
            </div>
            <div class="row">
                <div class="col-sm-12" :class="tab == 'summary' ? 'col-md-6' : 'col-md-4'"> 
                    <date-range-picker class="w-100 mb-2"
                        :minDate="minDate"
                        ref="picker"
                        v-model="dateRange"
                        :opens="'right'"
                        :autoApply="true"
                        :showDropdowns="true" 
                        :always-show-calendars="false"
                        :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                        @showCustomRange="showCustomRangeCalendars=true"
                        @update="filterByDate">
                    </date-range-picker>
                </div>
                <div class="mb-2 col-sm-12" :class="tab == 'summary' ? 'col-md-6' : 'col-md-4'">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0" >
                                    <i class="fas fa-store"></i>
                                </label>
                                <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                    <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="tab == 'list'" class="col-sm-12 col-md-4 mb-2">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0" >
                                    <i class="fas fa-box-usd"></i>
                                </label>
                                <multiselect :value="selectedAmountTypeTab" label="text" track-by="id" :options="amountType" :searchable="false" :show-labels="false" openDirection="below" @select="filterByAmountType">
                                    <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="link text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
        <ul class="nav nav-tabs mt-2" role="tablist">
            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.summary_type" :key="c.id">
                <a :class="{'active': selectedSummaryType == c.id}" class="nav-link" role="tab" @click="filterByType(c.id)">{{c.text}}</a>
            </li>
        </ul>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: "outstandingsFilter",
    components:{
        DateRangePicker
    },
    data(){
        let startDate = moment().startOf('day');
        let endDate = moment().endOf('day');

        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            tab: "summary",
            selectedAmountTypeTab: {id: "all", text: this.$i18n.t('label.all', {'item': ''})},
            selectedSummaryType: "customer",
            searchCredit: "", dateRange: { startDate, endDate }, dateBalance: { startDate },
            outlet: [{id: "all", text:this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}],
            selectedOutlet: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            dateFilter: "", searchFilter: "", typeFilter: "",
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: ""
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)[0]

            var a = Object.assign({}, this.selectedAmountTypeTab)
            this.selectedAmountTypeTab = this.amountType.filter(obj=> obj.id == a.id)[0]
        }
    },
    computed: {
        amountType(){
            return[
                {id: 'all', text: this.$i18n.t('label.all', {'item': ''})},
                {id: 'topup', text: this.$i18n.t('salon_report.outstandings.outstandings')},
                {id: 'redeem', text: this.$i18n.t('salon_report.outstandings.collection')},
            ]
        }
    },
    methods:{
        clearFilter(){
            if(this.tab == 'summary' && this.selectedSummaryType == 'customer'){
                this.searchCredit = ""
                var data = {
                    dateBalance: this.dateBalance,
                    date: this.dateRange,
                    search: this.searchCredit,
                    listType: this.selectedAmountTypeTab.id, 
                    summaryType: this.selectedSummaryType
                }
                this.$emit('setCreditBalance', data)

            }else{
                let startDate = moment().startOf('day');
                let endDate = moment().endOf('day');

                this.dateRange = {startDate, endDate}
                this.dateBalance = {startDate}
                this.searchCredit = ""
                this.selectedAmountTypeTab = {id: "all", text: this.$i18n.t('label.all', {'item': ''})}
                this.selectedSummaryType = "customer"
                this.selectedOutlet = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}
                this.filterOutstandingsItem();
            }
            
        },
        filterSearch(){
            this.filterOutstandingsItem();
        },
        filterByEndDate(date){
            date.startDate = moment(date.startDate).endOf('day')
            this.dateBalance = date
            this.filterOutstandingsItem();
        },
        filterByDate(date){
            date.endDate = moment(date.endDate).endOf('day')
            this.dateRange = date
            this.filterOutstandingsItem();
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterOutstandingsItem();
        },
        filterByAmountType(item){
            this.selectedAmountTypeTab = item;
            this.filterOutstandingsItem()
        },
        filterByType(type){
            this.selectedSummaryType = type
            if(this.tab == 'list'){
                this.filterOutstandingsItem()
            }else{
                if(type == 'date'){
                    this.filterOutstandingsItem()
                }else{
                    var data = {
                        dateBalance: this.dateBalance,
                        date: this.dateRange,
                        search: this.searchCredit,
                        listType: this.selectedAmountTypeTab.id, 
                        summaryType: this.selectedSummaryType,
                        outletID: this.selectedOutlet.id,
                    }
                    this.$emit('setCreditBalance', data)
                }
            } 
        },
        filterOutstandingsItem(){
            var filterObj = {
                dateBalance: this.dateBalance,
                date: this.dateRange,
                search: this.searchCredit,
                listType: this.selectedAmountTypeTab.id, 
                summaryType: this.selectedSummaryType,
                outletID: this.selectedOutlet.id,
            }
            this.tab == 'summary' ? this.$emit('filterCreditSummary', filterObj) : this.$emit('filterCreditList', filterObj);
        },
        updateSummaryType(tab){
            this.tab = tab;
            this.selectedSummaryType = 'customer'
            this.filterByType(this.selectedSummaryType);
        }, 
        setExportData(data){
            this.exportData = data.data
            this.exportFields = data.fields
            this.exportHeaders = data.headers
            this.exportFileName = data.fileName
        }
    },
    mounted(){
        let $vm = this;
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlets);

        if (this.outlet[1]) {
            this.selectedOutlet = this.outlet[1]
        }

        $vm.filterOutstandingsItem();
    }
}
</script>
<style scoped>
.link, .nav-link{
    cursor: pointer;
}
</style>